import { render, staticRenderFns } from "./TouchScreen.vue?vue&type=template&id=2470a55a&scoped=true&"
import script from "./TouchScreen.vue?vue&type=script&lang=js&"
export * from "./TouchScreen.vue?vue&type=script&lang=js&"
import style0 from "./TouchScreen.vue?vue&type=style&index=0&id=2470a55a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470a55a",
  null
  
)

export default component.exports